import { COLORS } from 'helpers/globals'

const hide = { display: 'none' }
const show = { display: 'inline-block' }
const input = {
  height: '2.4rem !important',
  fontSize: '1.4rem',
  paddingLeft: '.3rem !important',
  maxWidth: '85% !important',
  background: 'white !important'
}
const close = {
  cursor: 'pointer',
  fontSize: '2.5rem',
  marginLeft: '.5rem',
  position: 'absolute',
  bottom: 0,
  '&:hover': { color: COLORS.primary }
}

export default {
  container: {
    display: 'inline-block',
    flex: '1 1 auto',
    height: 25,
    overflowY: 'hidden',
    verticalAlign: 'bottom',
    position: 'relative'
  },
  changeLocationButton: {
    // add button from TopBar/style
    margin: '0 1.25rem 0 0',
    color: COLORS.primary,
    border: 0,
    padding: 0,
    fontSize: '1.3rem',
    '&:hover': {
      color: COLORS.secondary
    }
  },
  searchIcon: {
    marginRight: 3,
    top: -2,
    fontSize: '1.6rem'
  },
  closeIcon: {
    fontSize: '2rem'
  },
  hide,
  show,
  input,
  showInput: {
    ...input,
    ...show
  },
  hideInput: {
    ...input,
    opacity: 0,
    display: 'block'
  },
  close,
  showClose: {
    ...close,
    ...show
  },
  hideClose: {
    ...close,
    ...hide
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationSearch/style.js